<template>
  <v-main>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12">
          <v-card :class="reportClasses">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  <v-icon v-if="isPageDisabled" color="yellow">
                    warning
                  </v-icon>
                  Отчет <span>ЛГБКТИ+ координатора</span>
                </h3>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-card ref="form">
            <div class="text-center">
              <v-dialog
                v-model="dialoLoading"
                persistent
                width="300">
                <v-card
                  color="primary"
                  dark>
                  <v-card-text>
                    {{ dialogText }}
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0" />
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-col cols="12" sm="2">
                  <BaseDatePicker ref="date"
                                  :key="dateForceUpdateKey"
                                  :rules="numericRules"
                                  :error-messages="errorMessages"
                                  :value="date"
                                  :disabled="isPageDisabled"
                                  @dateUpdated="dateUpdated"
                                  label="Дата" />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field ref="supportGroupsCnt"
                                v-model="supportGroupsCnt"
                                :rules="numericRules"
                                :disabled="isPageDisabled"
                                label="Групп взаимопомощи"
                                type="number" />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field ref="onlineConsultCnt"
                                v-model="onlineConsultCnt"
                                :rules="numericRules"
                                :error-messages="errorMessages"
                                :disabled="isPageDisabled"
                                label="Онлайн консультирований"
                                type="number"
                                required />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field ref="farEvents"
                                v-model="farEvents"
                                :rules="numericRules"
                                :error-messages="errorMessages"
                                :disabled="isPageDisabled"
                                label="Переговоры о присутствии социальных работников ФАР на мероприятиях"
                                hint="Переговоры о присутствии социальных работников ФАР на мероприятиях"
                                persistent-hint
                                type="number"
                                required />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field ref="outreach"
                                v-model="outreach"
                                :rules="numericRules"
                                :error-messages="errorMessages"
                                :disabled="isPageDisabled"
                                label="Участие в аутриче на профилактических мероприятиях для гей сообщества"
                                hint="Участие в аутриче на профилактических мероприятиях для гей сообщества"
                                persistent-hint
                                type="number"
                                required />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <ReportIndicatorsForm ref="indicators"
                                      :is-disabled="isPageDisabled"
                                      :products-list="productsList"
                                      @updateCustomers="updateCustomers"
                                      @updateProducts="updateProducts"
                                      @updateConsultings="updateConsultings">
                  <template slot="afterCust">
                    <v-text-field ref="oldCustomersCnt"
                                  v-model="oldCustomersCnt"
                                  :error-messages="errorMessages"
                                  :disabled="true"
                                  style="margin-left: 20px; margin-top: 15px;  padding-right: 20px;"
                                  label="Количество участников с кодами"
                                  type="number"
                                  required />
                  </template>
                </ReportIndicatorsForm>
              </v-row>
              <!--              </v-card>-->
            </v-col>
            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-btn
                  v-show="reportId"
                  @click="cancelReport"
                  outlined
                  color="teal"
                  class="mb-2">
                  Назад
                </v-btn>
                <v-btn v-if="isPageDisabled"
                       @click="clearReport"
                       color="primary"
                       class="mb-2">
                  Новый отчет
                </v-btn>
                <v-tooltip v-model="tooltipShow"
                           :disabled="!formDisabled"
                           top
                           color="error">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn
                        v-if="!isPageDisabled"
                        :disabled="formDisabled"
                        v-on="on"
                        @click="checkDuplicates"
                        color="primary"
                        class="mb-2">
                        Сохранить
                      </v-btn>
                    </div>
                  </template>
                  <span>Заполнены не все поля!</span>
                </v-tooltip>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
      <CommonModals :dialog-report-duplicate.sync="dialogReportDuplicate"
                    :dialog-error-submit.sync="dialogErrorSubmit"
                    :dialog-empty-report.sync="dialogEmptyReport"
                    :dialog-submit.sync="dialogSubmit"
                    :error="error"
                    @checkDuplicates="checkDuplicates"
                    @clearReports="clearReport"
                    @addDuplicate="addDuplicate"
                    @toReports="toReports" />
    </v-container>
  </v-main>
</template>

<script>
import {mapState} from 'vuex'
import BaseDatePicker from '../../base/BaseDatePicker'
import ReportIndicatorsForm from './ReportIndicatorsForm'
import ReportsMixin from './ReportsMixinOld'
import CommonModals from './CommonModals'

export default {
  name: "ReportLGBTQ",
  components: {ReportIndicatorsForm, BaseDatePicker, CommonModals},
  mixins: [ReportsMixin],
  props: {

  },
  data () {
    return {
      showQr: false,
      dateForceUpdateKey: 1,
      tooltipShow: false,
      errorMessages: '',
      loading: true,
      dialoLoading: !!this.reportId,
      selectedUsers: [],
      alertColor: 'green',
      alert: false,
      supportGroupsCnt: null,
      oldCustomersCnt: 0,
      onlineConsultCnt: null,
      farEvents: null,
      outreach: null,
      numericRules: [
        v => !!v || v===0 || 'Поле обязательно',
        v => !isNaN(v) || 'Допустимы только численные значения'
      ]
    }
  },
  watch: {
    reportId (newValue) {
      newValue === null ? this.clearReport() : newValue
    },
    form (newValue) {
      sessionStorage.setItem(this.sessionStorageName, JSON.stringify(newValue))
    },
    savedData (data) {
      let rep = data.report
      if  (rep) {
        this.selectedUsers = rep.users ? rep.users : []
        this.date = data.report['date'] ? data.report['date'] : this.date
        this.hours = rep.hours ? rep.hours : 0
        this.supportGroupsCnt= rep.supportGroupsCnt ? parseInt(rep.supportGroupsCnt) : 0
        this.oldCustomersCnt=  rep.oldCustomersCnt ? parseInt(rep.oldCustomersCnt) : 0
        this.onlineConsultCnt=  rep.onlineConsultCnt ? parseInt(rep.onlineConsultCnt) : 0
        this.farEvents=  rep.farEvents ? parseInt(rep.farEvents) : 0
        this.outreach=  rep.outreach ?parseInt(rep.outreach) : 0
        this.selectedProducts = data.selectedProducts
        this.selectedConsultings = data.selectedConsultings
        this.customers = data.customers
        this.dialoLoading = false
        this.$refs['indicators'].populateReport(data)

      }

    }
  },
  methods: {
    updateProducts (newVal) {
      this.selectedProducts = newVal
    },
    updateCustomers (newVal) {
      let vm = this
      newVal.forEach(function (v, i) {
        vm.$set(vm.customers, i, v)
      })
     this.oldCustomersCnt = newVal.length
    },
    updateConsultings (newVal) {
      this.selectedConsultings = newVal
    },
    clearReport () {
      this.isPageDisabled = false
      this.alertConsulting = false
      this.alertProducts = false
      this.errorList = []
      this.date = new Date().toISOString().substr(0, 10)
      this.customers = []
      this.selectedProducts = []
      this.$set(this, 'customers', [])
      this.$set(this, 'selectedProducts', [])
      this.$set(this, 'selectedConsultings', [])
      sessionStorage.setItem(this.sessionStorageName, null)
      this.dialogSubmit = false
      this.dialogReportDuplicate = false
      // this.$refs['indicators'].clear()
    },
  },
  computed: {
      form () {
      return {
        date: this.date,
        products: this.selectedProducts,
        consultings: this.selectedConsultings,
        customers: this.customers,
        supportGroupsCnt: this.supportGroupsCnt,
        oldCustomersCnt: this.oldCustomersCnt,
        onlineConsultCnt: this.onlineConsultCnt,
        farEvents: this.farEvents,
        outreach: this.outreach,
      }
    },
    // productsListFiltered () {
    //   let res = this.productsList ? this.productsList.filter(p => {
    //     if ('producttype' in p && p.producttype !== null) return [4, 3, 1].indexOf(p.producttype.id) > -1 &&
    //         (p.report_type.indexOf('ЛГБТКИ+') > -1 )
    //   }) : []
    //   return res
    // },
    // consultListFiltered () {
    //   return this.productsList.filter(p => {
    //     if ('producttype' in p && p.producttype !== null) return (p.producttype.id === 2 && p.report_type.indexOf('ЛГБТКИ+') > -1)
    //   })
    // },
    // usersListFiltered () {
    //   let ul = []
    //   this.users.forEach(obj => {
    //     if (obj.user_roles) {
    //       let roles = obj.user_roles
    //       roles.forEach(r => {
    //         if (r.id === 1) {
    //           obj['full_name'] = obj.name + ' ' + obj.surname
    //           ul.push(obj)
    //         }
    //       })
    //     }
    //   })
    //   return ul
    // },
    // usersListCaseFiltered () {
    //   let ul = []
    //   this.users.forEach(obj => {
    //     if (obj.user_roles) {
    //       let roles = obj.user_roles
    //       roles.forEach(r => {
    //         if (r.id === 2) {
    //           obj['full_name'] = obj.name + ' ' + obj.surname
    //           ul.push(obj)
    //         }
    //       })
    //     }
    //   })
    //   return ul
    // },
    ...mapState({
      productsList: state => state.tableData.products
    })
  },
  mounted () {
    this.dialogText = 'Загружаются данные отчета'
    let data = this.onMount()
  },
  beforeRouteLeave (to, from, next) {
    this.clearReport()
    next()

  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // access to component instance via `vm`
      vm.dateForceUpdateKey = vm.dateForceUpdateKey + 1
    })

  }

}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030
}

.outreach-header {
  background-color: #1976d2 !important;
  opacity: 0.8;
  padding: 10px
}

.case-header {
  background-color: #ffc107 !important;
  opacity: 0.8;
  padding: 10px
}

.read-only-header {
  background-color: gray !important;
  opacity: 0.8;
  padding: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportLGBTQ.vue